import React, { useState, useEffect } from 'react'
import moment from 'moment'
import TrashIcon from '@rsuite/icons/Trash';
import CloseIcon from '@rsuite/icons/Close';
import VisibleIcon from '@rsuite/icons/Visible';
import { useDispatch, useSelector } from 'react-redux'
import { setCurrentScore, setRModalData, setOpenRModal, setFileReport, setMatchFileProcessing, updateFileAllocation, setTempModule } from '../../../reducers/filesAllocationReducer';
import { getRequest, postRequest, showMessage } from '../../../config';
import { toggleModal } from '../../../reducers/modalReducer';
import ModalWrapper from '../../common/Modal/ModalWrapper';
import Button from '../../common/Button';
import { Divider } from '@mui/material';
import Send from "../../../../images/dataRepo/send.svg"
import Search from "../../../../images/dataRepo/search.svg"
import { KeyboardArrowDown } from '@mui/icons-material';

const TempImportSummaryModal = ({ modalType }) => {

    const dispatch = useDispatch()
    const { fileReport, currentScore, reportHistories, profileClass } = useSelector(state => state.fileAllocation)
    const { selectedCompany: company } = useSelector(state => state.company)
    let modal = useSelector(state => state.modal);
    const isModified = fileReport?.importResult && Object.entries(fileReport.importResult).some(([key, value]) => value.isModified === true);

    // TempModule state — fetched using fileReport.moduleName (ObjectId or slug)
    const [activeModule, setActiveModule] = useState(null);

    // File preview state
    const [previewFile, setPreviewFile] = useState(null);

    const { tempModule: cachedTempModule } = useSelector(state => state.fileAllocation);

    useEffect(() => {
        if (modal['open'] !== modalType) return;
        if (!fileReport?.moduleName || !company?._id) return;

        const matchesCompany = !cachedTempModule?.companyId
            || String(cachedTempModule.companyId) === String(company._id);
        const matchesModule = cachedTempModule && [cachedTempModule.moduleKey, cachedTempModule.moduleSlug, cachedTempModule.slug, cachedTempModule.moduleName]
            .filter(Boolean)
            .map((v) => String(v).toLowerCase())
            .includes(String(fileReport.moduleName).toLowerCase());

        if (cachedTempModule && matchesCompany && matchesModule) {
            setActiveModule(cachedTempModule);
            return;
        }

        getRequest(`/modules/temp-modules/by-name/${fileReport.moduleName}?companyId=${company._id}`)
            .then(res => {
                if (res?.code === 200 && res?.body) {
                    setActiveModule(res.body);
                    dispatch(setTempModule({
                        ...res.body,
                        moduleName: res.body.moduleName || fileReport.moduleName,
                        moduleSlug: res.body.moduleSlug || fileReport.moduleName,
                        companyId: company._id,
                    }));
                }
            });
    }, [modal['open'], fileReport?.moduleName, company?._id, cachedTempModule, dispatch]);

    const handleFilePreview = (file) => {
        const url = file.location || file.url;
        if (!url) return;
        setPreviewFile({ name: file.originalname || file.title, url });
    };

    const onClickFileImportAuditLog = async (fileReportId) => {
        const res = await getRequest(`/company/getFileReportLogs/${fileReportId}`);
        dispatch(toggleModal({ open: 'fileReportAuditLog' }))
    };

    const onClickComplete = async () => {
        const moduleId = activeModule?._id;
        let newFileReport = {
            ...fileReport,
            status: 'Complete',
            currentScore: currentScore
        };

        newFileReport = {
            ...newFileReport,
            importResult: Object.fromEntries(
                Object.entries(newFileReport.importResult)
                    .filter((item) => item[1]['isModified'])
                    .map(([key, value]) => [key, {
                        file: value['file'],
                        section: value['section'],
                        originalSection: value['originalSection']
                    }])
            )
        };

        dispatch(toggleModal({ open: '' }))
        const resp = await postRequest(`/modules/allocateFiles`, { companyId: company._id, moduleId, fileReport: newFileReport });
        if (!resp || resp.code === 400) return;

        const updatedReport = resp.body['report'];
        const savedQuestions = resp.body?.savedQuestions;
        if (moduleId && savedQuestions?.length) {
            dispatch(updateFileAllocation({
                tempModuleAllocationPatch: { moduleId: String(moduleId), savedQuestions },
            }));
        }

        for (let i = 0; i < reportHistories.length; i++) {
            if (reportHistories[i]['_id'] == updatedReport['_id']) {
                reportHistories[i] = updatedReport;
                break;
            }
        }
        showMessage(resp['message']);
        dispatch(setMatchFileProcessing(false))
        dispatch(updateFileAllocation({ underProcessingTab: '' }))
    };

    const onClickReallocationComplete = async () => {
        const moduleId = activeModule?._id;
        const companyId = company?._id;
        const fileReportData = {
            ...fileReport,
            status: 'Complete',
            currentScore: currentScore
        };
        dispatch(setFileReport(fileReportData));
        dispatch(toggleModal({ open: '' }));
        const resp = await postRequest(`/modules/allocateFiles`, { companyId, moduleId, fileReport: fileReportData });
        if (!resp || resp.code === 400) return;

        const updatedReport = resp.body['report'];
        const savedQuestions = resp.body?.savedQuestions;
        if (moduleId && savedQuestions?.length) {
            dispatch(updateFileAllocation({
                tempModuleAllocationPatch: { moduleId: String(moduleId), savedQuestions },
            }));
        }

        for (let i = 0; i < reportHistories.length; i++) {
            if (reportHistories[i]['_id'] == updatedReport['_id']) {
                reportHistories[i] = updatedReport;
                break;
            }
        }
        showMessage(resp['message']);
        dispatch(setMatchFileProcessing(false));
        dispatch(updateFileAllocation({ underProcessingTab: '' }));
    };

    const getSectionNameFromSection = (section, qNo) => {
        if (section.sectionNo == qNo) {
            const name = section.sectionName || '';
            return { displayName: name, sectionOnly: name };
        }

        // TempModule sections have a flat questions array with qNo field
        if (section.questions) {
            const questions = Array.isArray(section.questions)
                ? section.questions
                : Object.values(section.questions);
            for (const question of questions) {
                if (question.qNo == qNo) {
                    const sectionOnly = section.sectionName || '';
                    return { displayName: question.qDescription || sectionOnly, sectionOnly };
                }
            }
        }

        return null;
    };

    const getSectionName = (module, qNo, file, key) => {
        if (qNo == "DXXX" || qNo == "SXXX") return {
            displayName: <div
                onClick={() => handleEditDispatch({ key: key, fileName: file.originalname, from: 'fileReport', actionType: "move", fileData: file, index: "0" })}
                className='bg62 br10px df aic p1rem jcsb fsi'
            >
                <p>Please select section</p>
                <KeyboardArrowDown className='c3' />
            </div>,
            sectionOnly: ''
        };

        const sections = [...(module?.sections || [])];
        for (const section of sections) {
            const result = getSectionNameFromSection(section, qNo);
            if (result) return { displayName: `${qNo} ${result.displayName}`, sectionOnly: result.sectionOnly };
        }

        // Fallback: use sectionName from backend allocation if available
        const entry = fileReport?.importResult && Object.values(fileReport.importResult).find(
            r => r.section?.includes(qNo) && r.sectionName
        );
        if (entry?.sectionName) return { displayName: `${qNo} ${entry.sectionName}`, sectionOnly: entry.sectionName };

        return { displayName: qNo, sectionOnly: '' };
    };

    const handleEditDispatch = (action) => {
        dispatch(setRModalData({ ...action }))
        dispatch(setOpenRModal(true))
    }

    function isSubarray(subarray, array) {
        const sortedSubarray = subarray.slice().sort();
        const sortedArray = array.slice().sort();
        let i = 0;
        return sortedArray.some((element) => {
            if (element === sortedSubarray[i]) i++;
            return i === sortedSubarray.length;
        });
    }

    const calcAccuracyScore = (count) => {
        let allocated = 0;
        for (const key of Object.keys(fileReport.importResult)) {
            const currentSection = fileReport.importResult[key]['section'];
            const oldSection = fileReport.importResult[key]['originalSection'];
            if (oldSection.includes("DXXX") || oldSection.includes("SXXX")) continue;
            if (isSubarray(oldSection, currentSection)) allocated++;
        }
        const totalCount = count ?? Object.keys(fileReport.importResult).length;
        dispatch(setCurrentScore(!totalCount ? 0 : Math.round(allocated / totalCount * 100)))
        return !totalCount ? 0 : Math.round(allocated / totalCount * 100);
    };

    const removeSectionFromImport = async (fileKey, index) => {
        let sections = [...fileReport.importResult[fileKey]['section']];
        const _fileReport = { ...fileReport };
        const qNo = sections[index];

        sections.splice(index, 1);

        const file = _fileReport.importResult[fileKey]['file'];

        if (sections.length === 0) {
            const { [fileKey]: removedFile, ...restOfFileReport } = _fileReport.importResult;
            _fileReport.importResult = restOfFileReport;
        } else {
            _fileReport.importResult[fileKey] = {
                ..._fileReport.importResult[fileKey],
                section: sections
            };
        }

        const score = calcAccuracyScore(Object.keys(_fileReport.importResult).length);

        await postRequest(`/company/deleteSection`, {
            companyId: company._id,
            fileReportId: _fileReport['_id'],
            fileKey,
            index,
            qNo,
            score,
            file
        });

        dispatch(setFileReport(_fileReport));
    };

    const getImportResultEntryHTML = key => {
        const fileName = fileReport.importResult[key].file['originalname'];
        const file = fileReport.importResult[key].file;
        const section = fileReport.importResult[key]['section'];
        // Use fetched TempModule data instead of company.modules[tab]
        const module = activeModule;

        if (Array.isArray(section)) {
            return <>
                {
                    section.map((qNo, index) => {
                        const { displayName, sectionOnly } = getSectionName(module, qNo, file, key);
                        return <React.Fragment key={`${index + section.length - 1}-section-allocate`}>
                            <tr className={`${index == section.length - 1 ? 'fis-tr' : ''}`}>
                                <td className={`tal fis-td mx1rem fs14px fw600 tdu bg1 lightDot ${index != 0 ? 'vh' : ''} ${qNo == "DXXX" ? 'red' : (fileReport['status'] == 'In Progress' ? 'orange' : 'green')}`}>
                                    <span className="cp" onClick={() => handleFilePreview(file)} data-tooltip="Click to preview file">
                                        {fileName}
                                    </span>
                                </td>
                                <td className={`tal mx1rem fs14px fw400 bg1 c15`}>
                                    {sectionOnly}
                                </td>
                                <td className={`tal mx1rem fs14px fw400 bg1 c15`}>
                                    {displayName}
                                </td>
                                {fileReport['status'] == 'In Progress' && (
                                    <td className={`mx1rem fs1rem fw600 bg1 tal fis-td fis-td-action`}>
                                        <div className="df fdr jcc aic">
                                            {qNo !== "DXXX" ?
                                                <Send
                                                    data-tooltip={"Move"}
                                                    className="mr1rem cp"
                                                    onClick={() => handleEditDispatch({ key: key, fileName: file.title, from: 'fileReport', actionType: "move", fileData: file, index })}
                                                /> : null
                                            }
                                            <TrashIcon data-tooltip={"Delete"} onClick={() => removeSectionFromImport(key, index)} className="cp f9 ml1rem" />
                                        </div>
                                    </td>
                                )}
                            </tr>
                        </React.Fragment>
                    })
                }
            </>
        } else {
            const { displayName, sectionOnly } = getSectionName(module, section, file, key);
            return <>
                <tr className={`fis-tr`}>
                    <td className={`tal fis-td mx1rem fs1rem fw600 bg1`}>
                        <span className="cp tdu" onClick={() => handleFilePreview(file)} data-tooltip="Click to preview file">
                            {fileName}
                        </span>
                    </td>
                    <td className={`tal fis-td mx1rem fs1rem fw600 bg1 fis-td`}>
                        {sectionOnly}
                    </td>
                    <td className={`tal fis-td mx1rem fs1rem fw600 bg1 fis-td`}>
                        {displayName}
                    </td>
                    {fileReport['status'] == 'In Progress' && (
                        <td className={`mx1rem fs1rem fw600 bg1 tal fis-td fis-td-action`}>
                            <div className="df fdr jcc aic">
                                <TrashIcon data-tooltip={"Delete"} onClick={() => removeSectionFromImport(key, 0)} className="cp f9" />
                            </div>
                        </td>
                    )}
                </tr>
            </>
        }
    };

    if (fileReport && Object.keys(company).length && modal['open'] == modalType) {
        return (
            <>
                <ModalWrapper
                    modalType={modalType}
                    modalCardClasses={`mah80 p2rem`}
                    customStyle={{ maxWidth: '1400px', padding: '2rem', zIndex: 9, marginTop: '2rem', transition: 'max-width 0.3s ease' }}
                    girlComponent={!previewFile ? <div style={{ position: 'relative' }}>
                        {
                            fileReport.importResult && Object.keys(fileReport.importResult).filter(key => fileReport.importResult[key]['section'].some((element) => element.includes("DXXX") || element.includes("SXXX"))).length > 0
                                ? <img src={require("../../../../images/dataRepo/sorryMessage.png")} alt="messageLadie" className='animateRight' />
                                : <img src={require("../../../../images/dataRepo/fillingassistantGirl.png")} alt="messageLadie" className='animateRight' />
                        }
                    </div> : null}
                >
                    <div className="df" style={{ gap: '1.5rem' }}>
                        {/* Left side */}
                        <div style={{ flex: previewFile ? '0 0 50%' : '1 1 100%', minWidth: 0, transition: 'flex 0.3s ease' }}>
                            <div className='df jcsb pr'>
                                <div className='df jcfs aic'>
                                    <img src={require("../../../../images/dataRepo/file_placement.svg")} alt={"fileManagement"} />
                                    <h1 className="c15 fw600 fs20px mb0rem ml0-5rem">Filing Assistant</h1>
                                </div>
                                <div className='df aic' style={{ gap: '0.5rem' }}>
                                    <button
                                        onClick={() => onClickFileImportAuditLog(fileReport['_id'])}
                                        className='cp tac c1 bg5 c15 br20px px1-5rem py0-5rem fw500'>
                                        Log
                                    </button>
                                </div>
                            </div>

                            <h3 className="w100 fw400 fs13px c37 df jcfs aic mt1-5rem">
                                {fileReport?.['lastAllocatedBy'] ? (
                                    <>
                                        <span className='mr0-5rem'>Reallocated by&nbsp;</span>
                                        <p className={`w2rem h2rem jcc aic dib wsn mr0-5rem`}>
                                            {fileReport?.['lastAllocatedBy']?.['profile']
                                                ? <img src={fileReport?.['lastAllocatedBy']?.['profile']} className={`w2rem h2rem df jcc aic br100 ${profileClass}`} data-tooltip={fileReport?.['lastAllocatedBy']?.['firstName'] ? (fileReport?.['lastAllocatedBy']?.['firstName'] + " " + fileReport?.['lastAllocatedBy']?.['lastName']) : "?"} />
                                                : <img src={require("../../../../images/profile-photo.png")} className={`w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`} data-tooltip={fileReport?.['lastAllocatedBy']?.['firstName'] ? (fileReport?.['lastAllocatedBy']?.['firstName'] + " " + fileReport?.['lastAllocatedBy']?.['lastName']) : "?"} />
                                            }
                                        </p>
                                        <p className={`df jcc aic br100 fw500 mr0-5rem`}>
                                            {`${fileReport?.['lastAllocatedBy']?.['firstName'] ? `${fileReport?.['lastAllocatedBy']?.['firstName']} ${fileReport?.['lastAllocatedBy']?.['lastName'] ? fileReport?.['lastAllocatedBy']?.['lastName'] : ""}` : ""}`}
                                        </p>
                                        &nbsp;{moment(fileReport['lastAllocatedOn']).format('lll')}
                                    </>
                                ) : (
                                    <>
                                        Imported by: &nbsp;
                                        <span className={`w2rem h2rem jcc aic dib wsn mr0-5rem`}>
                                            {fileReport?.['importBy']?.['profile']
                                                ? <img src={fileReport?.['importBy']?.['profile']} className={`w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`} data-tooltip={fileReport?.['importBy']?.['firstName'] ? (fileReport?.['importBy']?.['firstName'] + " " + (fileReport?.['importBy']?.['lastName'] ? fileReport?.['importBy']?.['lastName'] : "")) : "?"} />
                                                : <img src={require("../../../../images/profile-photo.png")} className={`w2rem h2rem df jcc aic br100 ${profileClass} mr0-5rem`} data-tooltip={fileReport?.['importBy']?.['firstName'] ? (fileReport?.['importBy']?.['firstName'] + " " + (fileReport?.['importBy']?.['lastName'] ? fileReport?.['importBy']?.['lastName'] : "")) : "?"} />
                                            }
                                        </span>
                                        <p className={`df jcc aic ttc br100 fw600 c36`}>
                                            {`${fileReport?.['importBy']?.['firstName'] ? `${fileReport?.['importBy']?.['firstName']} ${fileReport?.['importBy']?.['lastName'] ? fileReport?.['importBy']?.['lastName'] : ""}` : ""}`}
                                        </p>
                                        <span className='c36'>
                                            &nbsp;{moment(fileReport['importDate']).format('MMM DD, YYYY, HH:mm A')}
                                        </span>
                                    </>
                                )}
                            </h3>

                            <Divider style={{ marginTop: "16px", marginBottom: "16px" }} />

                            <div className="dg gg0-5rem mb2rem fs1rem mah300px oya">
                                <table className="fis bcc">
                                    <thead>
                                        <tr>
                                            <th className="tal fs14px fw400 c37" style={{ width: '45%' }}>Files</th>
                                            <th className="tal fs14px fw400 c37" style={{ width: '10%' }}>Section Name</th>
                                            <th className="tal fs14px fw400 c37" style={{ width: '35%' }}>Allocated Section</th>
                                            {fileReport['status'] == 'In Progress' && (
                                                <th className="fs14px fw400 c37" style={{ width: '10%' }}>Actions</th>
                                            )}
                                        </tr>
                                    </thead>
                                    {fileReport.importResult && Object.keys(fileReport.importResult).filter(key => fileReport.importResult[key]['section'].some((element) => !element.includes("DXXX") && !element.includes("SXXX"))).length > 0 && (
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <h1 className={"c15 fs18px fw500 tal"}>Allocated files</h1>
                                                </td>
                                            </tr>
                                            {fileReport.importResult && Object.keys(fileReport.importResult).filter(key => fileReport.importResult[key]['section'].some((element) => !element.includes("DXXX") && !element.includes("SXXX"))).map(getImportResultEntryHTML)}
                                        </tbody>
                                    )}
                                </table>

                                {fileReport.importResult && Object.keys(fileReport.importResult).filter(key => fileReport.importResult[key]['section'].some((element) => element.includes("DXXX") || element.includes("SXXX"))).length > 0 && (<>
                                    <h1 className={"c15 fs18px fw500 tal mt1rem ml1rem"}>Unallocated Bin: Please reallocate files <span className='c4'>*</span></h1>
                                    <table className="fis bcc">
                                        <thead className='dn'>
                                            <tr>
                                                <th className="fis-th w40 bbn"></th>
                                                <th className="fis-th bbn"></th>
                                                <th className="fis-th w60 bbn"></th>
                                                {fileReport['status'] == 'In Progress' && (
                                                    <th className="fis-th fis-th-action bbn"></th>
                                                )}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {fileReport.importResult && Object.keys(fileReport.importResult).filter(key => fileReport.importResult[key]['section'].some((element) => element.includes("DXXX") || element.includes("SXXX"))).map(getImportResultEntryHTML)}
                                        </tbody>
                                    </table>
                                </>)}
                            </div>

                            <div className="df w100 fdr jcc">
                                {modal['from'] == 'reportHistory' ? (
                                    <>
                                        {isModified ? <Button
                                            onClick={onClickComplete}
                                            text={"Save Changes"}
                                            btnType='warning'
                                            customClassName="maw300px mr0-5rem"
                                        /> : null}
                                        <Button
                                            onClick={() => dispatch(toggleModal({ open: 'fileReportHistory' }))}
                                            text={"Back to List"}
                                            customClassName="maw300px c1 mr0-5rem"
                                        />
                                    </>
                                ) :
                                    fileReport['status'] == 'In Progress' && fileReport.importResult && Object.keys(fileReport.importResult).filter(key => fileReport.importResult[key]['section'].some((element) => !element.includes("DXXX") && !element.includes("SXXX"))).length > 0 && (
                                        <Button
                                            onClick={onClickReallocationComplete}
                                            text={"Confirm Allocation"}
                                            btnType='warning'
                                            customClassName="maw300px"
                                        />
                                    )
                                }
                            </div>

                            <div>
                                <div style={{ width: "60%", height: "1px", backgroundColor: "#82828256", opacity: "64%", margin: "24px auto" }}></div>
                                <div className='df aic jcc'>
                                    <Search className="mr0-5rem" />
                                    <p className='fs13px c37 fw400 mr0-5rem'>{fileReport.importResult && (
                                        <>
                                            [{Object.keys(fileReport.importResult).length}]imported files = [{Object.keys(fileReport.importResult).filter(key => fileReport.importResult[key]['section'].some((element) => !element.includes("DXXX") && !element.includes("SXXX"))).length}] allocated files +
                                            [{Object.keys(fileReport.importResult).filter(key => fileReport.importResult[key]['section'].some((element) => element.includes("DXXX") || element.includes("SXXX"))).length}] unallocated bin files
                                        </>
                                    )}</p>
                                    <p className='fs13px c37 fw400'>Allocation accuracy {currentScore}%</p>
                                </div>
                            </div>
                        </div>
                        {/* End left side */}

                        {/* Right side - File Preview Panel */}
                        {previewFile && (
                            <div style={{ flex: '0 0 48%', minWidth: 0, display: 'flex', flexDirection: 'column', borderLeft: '1px solid #e0e0e0', paddingLeft: '1rem', transition: 'all 0.3s ease' }}>
                                <div className="df jcsb aic" style={{ marginBottom: '0.75rem' }}>
                                    <div className="df aic" style={{ minWidth: 0 }}>
                                        <VisibleIcon style={{ marginRight: '0.5rem', color: '#6B7280', flexShrink: 0 }} />
                                        <h3 className="c15 fw600 fs14px mb0rem" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} data-tooltip={previewFile.name}>
                                            {previewFile.name}
                                        </h3>
                                    </div>
                                    <div className="df aic" style={{ flexShrink: 0, marginLeft: '0.5rem' }}>
                                        <a href={previewFile.url} target="_blank" rel="noopener noreferrer" className="cp mr0-5rem fs12px c36 fw500 tdu" data-tooltip="Open in new tab">Open</a>
                                        <CloseIcon className="cp" style={{ fontSize: '1rem', color: '#6B7280' }} onClick={() => setPreviewFile(null)} data-tooltip="Close preview" />
                                    </div>
                                </div>
                                <div style={{ flex: 1, borderRadius: '8px', overflow: 'hidden', border: '1px solid #e0e0e0', backgroundColor: '#f9fafb', minHeight: '400px' }}>
                                    <iframe src={previewFile.url} title={`Preview: ${previewFile.name}`} style={{ width: '100%', height: '100%', border: 'none', minHeight: '400px' }} />
                                </div>
                            </div>
                        )}
                    </div>
                </ModalWrapper>
            </>
        )
    } else {
        return (<></>)
    }
}

export default TempImportSummaryModal
